<div>
  <form class="form" role="form" class="search-container">
    <div class="d-flex">
      <div class="w70">
        <mat-form-field class="w100">
          <input matInput placeholder="Buscar" [matAutocomplete]="auto" [formControl]="searchBox">
        </mat-form-field>

        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let chapter of typeAhed$ | async"
            [value]="(GetCurrentChainElement().name==='Chapter')?(chapter.id):((GetCurrentChainElement().name==='Group')? chapter.grupo:chapter.id)"
            (click)="onClick(chapter)">
            {{chapter.descripcion}}
          </mat-option>
        </mat-autocomplete>

      </div>
      <div>
        <button aria-label="search" mat-icon-button="" class="mat-icon-button">
          <span class="mat-button-wrapper">
            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19" role="img" aria-hidden="true">search
            </mat-icon>
          </span>
          <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple="" ng-reflect-centered="true"
            ng-reflect-disabled="false" ng-reflect-trigger="[object HTMLButtonElement]"></div>
          <div class="mat-button-focus-overlay"></div>
        </button>
      </div>
    </div>
    <mat-chip-listbox class="f-s-12" aria-label="Fish selection">
      <mat-chip-option (click)="onChipClose(1)" *ngIf="chapter" color="primary">{{chapter}}<mat-icon
          class="mat-chip-remove mat-chip-trailing-icon mat-icon notranslate material-icons mat-icon-no-color"
          matchipremove="" role="img" aria-hidden="true">cancel</mat-icon>
      </mat-chip-option>
      <mat-chip-option (click)="onChipClose(2)" *ngIf="group" color="primary">{{group}}<mat-icon
          class="mat-chip-remove mat-chip-trailing-icon mat-icon notranslate material-icons mat-icon-no-color"
          matchipremove="" role="img" aria-hidden="true">cancel</mat-icon>
      </mat-chip-option>
      <mat-chip-option (click)="onChipClose(3)" *ngIf="threeDigitGroup" color="primary">{{threeDigitGroup}}<mat-icon
          class="mat-chip-remove mat-chip-trailing-icon mat-icon notranslate material-icons mat-icon-no-color"
          matchipremove="" role="img" aria-hidden="true">cancel</mat-icon>
      </mat-chip-option>
      <mat-chip-option (click)="onChipClose(4)" *ngIf="diagnosis" color="primary">{{diagnosis}}<mat-icon
          class="mat-chip-remove mat-chip-trailing-icon mat-icon notranslate material-icons mat-icon-no-color"
          matchipremove="" role="img" aria-hidden="true">cancel</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </form>
</div>
<div class="text-a-r p-t-15">
  <button mat-raised-button color="primary" (click)="AcceptCodes()" *ngIf="diagnosis && diagnosisCode">Aceptar</button>
</div>